import { SearchWizard } from "@/components/search-wizard/SearchWizard";

export default function NewSearchPage() {
  return <SearchWizard />;
}
